<ds-divider />
<div class="my-bets-footer">
    <div class="bet-information">
        <span class="my-bets-footer-date">{{ (showRegionCode ? (regionCode$ | async) : '') + (betPlacedDate() | msMyBetsEventDatePipe) }}</span>

        <span class="my-bets-footer-betslipid" (click)="copyToClipboard($event)">
            <vn-icon name="theme-copy-clipboard" size="12" />
            <span>{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslipId() }}</span>
        </span>
    </div>
    @if (isMyBetsFooterIconsVisible()) {
        <div class="my-bets-footer__icons">
            @if (showEditBetHistoryButton()) {
                <button
                    class="edit-bet-history-icon_button"
                    ds-button-icon
                    size="medium"
                    variant="flat-reduce"
                    kind="tertiary"
                    (click)="editBetHistory($event)">
                    <vn-icon name="theme-transaction-history" />
                </button>
            }

            @if (showShareMyBetButton()) {
                <ms-share-my-bet
                    size="small"
                    [placedBetInfo]="placedBetInfo()"
                    [expandable]="false"
                    [shouldShowShareMyBetLabel]="true"></ms-share-my-bet>
            }
        </div>
    }
</div>
